import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMsal, useAccount } from '@azure/msal-react';
import { useSelector, useDispatch } from "react-redux";
import { updateState, selectID, selectZip, selectiDB, selectVersion, updateUser, updateInstitution, updateDownloadProgress, setExpireSubscription, selectExpired, selectC5State } from "../features/counter/counterSlice";
import ProfileUser from './ProfileUser';
import ProfileInstitution from './ProfileInstitution';
import JSZip from 'jszip';
import { tgoa } from '../features/search/util';

const downloadWorker = new Worker(new URL('../workers/download.js', import.meta.url), { type: 'module' });


function Profile(props) {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const dispatch = useDispatch();
  const authID = useSelector(selectID);
  const zipFile = useSelector(selectZip);
  const ccmsversion = useSelector(selectVersion);
  const expired = useSelector(selectExpired);
  const currentC5State = useSelector(selectC5State);
  const [institution, setInstitution] = useState(' ');
  const iDB = useSelector(selectiDB);
  const [referral, setReferral] = useState(null);

  useEffect(() => {
    if (account && account.idTokenClaims && account.idTokenClaims !== authID.u) {

      let idTokenClaims = account.idTokenClaims;
      const email = idTokenClaims['signInNames.emailAddress'];
      const tgoaEmail = 'member@' + email.split('@')[1];
      const institution = tgoa[tgoaEmail];

      dispatch(updateUser({...account.idTokenClaims, i: institution || "single-multi"})); 
      window.dataLayer = window.dataLayer || [];
      // get the ip address        
      fetch('/api/getReqInfo')
        .then(response => response.json())
        .then(data => {
          dataLayer.push({
              'event': 'login',
              'given_name': idTokenClaims.given_name,
              'family_name': idTokenClaims.family_name,
              email,
              'ip': data.ip,
              'institution': institution,
              'origin': 'MSAL'
          });
        });
      dispatch(updateState({ zip: checkZip() }));
      if (zipFile === null) dispatch(updateState({ zip: checkZip() }));
    } else {
      const checkZipFile = checkZip();
      if (checkZipFile === 1) {
        dispatch(updateState({ zip: checkZipFile }));
      }
    }
  }, [account]);


  useEffect(() => {
    if ((zipFile === 1 || zipFile === null && (authID.u || authID.i)) && expired === false) {
      if (window.Worker) {
        iDB.keys().then(keys => {
          if (keys.length > 17100) {
            return; // The total count of keys
          } else {
            downloadWorker.postMessage({ command: 'fetchAndStore', idbKeys: keys, ccmsversion: ccmsversion.selected });
            downloadWorker.addEventListener('message', (event) => {
              console.log('Message from worker:', event.data);
            });
            downloadWorker.onmessage = function (event) {
              if (event.data.buffer) {
                JSZip.loadAsync(event.data.buffer).then(zip => {
                  dispatch(updateState({ zip }));
                });
              } else if (event.data.type === "progress") {
                dispatch(updateDownloadProgress(event.data.progress));
              }
            };
          }
        });
        // Clean up
        //return () => downloadWorker.terminate(); // TODO - when to terminate?
      } else {
        console.log("Web Workers are not supported in this browser.");
      }
    }
  }, [authID, expired]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    let newAuthID = { ...authID };
    try {
      let decodednstitution = JSON.parse(atob(localStorage.getItem('tgt')));
      let expiredDate = new Date(JSON.parse(atob(localStorage.getItem('tg_expirydate'))));

      if (decodednstitution && expiredDate > new Date()) {
        // valid token
        setInstitution(decodednstitution);
        newAuthID = { ...newAuthID, i: decodednstitution };

        if (typeof decodednstitution === 'object' && decodednstitution !== null && !Array.isArray(decodednstitution)) {
          dispatch(updateInstitution(decodednstitution));
          dispatch(updateState({ zip: checkZip() }));
        }

        // get the ip address        
        fetch('/api/getReqInfo')
          .then(response => response.json())
          .then(data => {
            dataLayer.push({
              'event': 'login',
              'ip': data.ip,
              'institution': decodednstitution.name,
              'origin': 'localStorage'
            });

            dispatch(updateState({ ip: data.ip }));
          });

      }
    } catch (error) {
      console.log("No valid token found." + error);
    }

    let referrer = document.referrer;

    const excludedReferrers = [
      /^https:\/\/.*\.app\.tg\.org\.au\//,
      /^https:\/\/app\.tg\.org\.au\//,
      /^https:\/\/tgldcdp\.tg\.org\.au\//
    ];

    const isExcluded = excludedReferrers.some(pattern => pattern.test(referrer));

    if (isExcluded) {
      // Use the previously saved referrer from localStorage if the current referrer is excluded
      referrer = localStorage.getItem('savedReferrer');
    } else {
      // Save the current referrer in localStorage if it is not excluded
      localStorage.setItem('savedReferrer', referrer);
    }

    let url;

    if (!referrer) {
      console.log("No valid referrer found.");
      url = '/api/getReqInfo';
    } else {
      setReferral(referrer);
      url = '/api/getReqInfo?r=' + referrer;
    }

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.sub.length > 0) {
          const ins = {
            name: data.sub[0]["_tg_customer_value@OData.Community.Display.V1.FormattedValue"],
            id: data.sub[0]["_tg_customer_value"],
            orgid: data.sub[0]["_organizationid_value"],
            shortName:data.account.tg_shortname||"cannot find short name",
          }
          
          dataLayer.push({
            'event': 'login',
            'ip': data.ip,
            'institution': ins.name,
            'origin': referrer? 'referrer' : 'IP'
          });
          
          let entitlements = data.entitlement;
          let expired = true;
          let expiredDate = new Date();
          if (entitlements !== undefined && entitlements.length > 0) {
            for (let entitlement of entitlements) {
              if (entitlement.tg_subscriptionid === "170") {
                const startDate = new Date(entitlement.startdate);
                 expiredDate = new Date(entitlement.tg_expirydate);
                 const today = new Date();
                 expiredDate.setHours(0, 0, 0, 0);
                 today.setHours(0, 0, 0, 0);
                expired = today < startDate || today > expiredDate;
                break;
              }
            }
          }

          dispatch(setExpireSubscription(expired));

          let ip_access_token = btoa(JSON.stringify({
            ...ins,
          }));
          localStorage.setItem('tgt', ip_access_token);
          localStorage.setItem('tg_expirydate', btoa(JSON.stringify(expiredDate)));
          setInstitution(ins);

         if (data.account && data.account.tg_shortname) {
              dispatch(updateState({ 
                C5State: {
                  ...currentC5State,
                  shortName: data.account.tg_shortname
                }
              }));
            }

          if (ins?.length === undefined) {
            dispatch(updateInstitution(ins));
            dispatch(updateState({ zip: checkZip() }));
          }
        }
        dispatch(updateState({ ip: data.ip }));
      });

  }, []);


  const checkZip = () => {
    let checkZipFile = (!zipFile && zipFile !== 1) ? 1 : zipFile;
    if ((!authID.u || authID.u === " ") && institution.length !== undefined) {
      checkZipFile = null;
    }

    if (authID.u === " " && authID.i === " ") {
      iDB.keys().then(keys => {
        if (keys.length > 15400) { // TODO: check against count in searchIndex
          console.log(`Cancelling download, found: ${keys.length} files in iDB.`);

          downloadWorker.postMessage({ command: 'Hydrated' });
          // delete zip file from cache storage.

        } else {
          console.log("downloading...keys=", keys.length);
          checkZipFile = (!zipFile && zipFile !== 1) ? 1 : zipFile; // Guest 
          if (checkZipFile === 1) {
            console.log("Guest", checkZipFile);
            dispatch(updateState({ zip: checkZipFile }));
          }
        }
      });
    }
    //console.log("checkZipFile",checkZipFile);
    return checkZipFile;
  }

  const handleLogout = () => {
    localStorage.removeItem("tgt");
    localStorage.removeItem("tg_expirydate");

      dispatch(updateState({ 
        C5State: {
          ...currentC5State,
          shortName: null
        }
      }));
      
    instance.logoutRedirect()
      .then(response => {
        console.log(response);
      })
      .catch(e => {
        console.error(e);
      });
  }

  if ((!authID.u || authID.u === " ") && institution.length !== undefined) {
    return false;
  }

  let authIDParse = (authID.u === " ") ? null : authID.u;

  return (<>
    {!authIDParse && institution.length === undefined &&
      <>
        <ProfileInstitution institution={institution} referral={referral} handleLoginClick={props.handleLoginClick} handleLogout={handleLogout} />
      </>}
    {authIDParse && <>
        <ProfileUser 
          authID={authID}
          handleEditProfile={() => {
              window.location.href = "https://tgldcdp.tg.org.au/index?login=dxp";
              return;
            }} 
          handleLogout={handleLogout}
        />
      </>}
  </>);
}

export default Profile;

Profile.propTypes = {
  handleLoginClick: PropTypes.func.isRequired,
};
